module.exports = __webpack_public_path__ + "img/notFinish2.9b81a5d4.png";